// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionFive-Product {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(157, 170, 241, 0.32);
  width: 100%;
  padding: 110px 180px 110px;
}
.sectionFive-Product .ProductSectionFive-content {
  display: flex;
  flex: 1 1;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 100px;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card {
  display: flex;
  flex: 1 1;
  width: 100%;
  height: auto;
  position: relative;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card:first-child {
  margin-right: 30px;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card:last-child {
  margin-left: 30px;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card .ProductSectionFive-content-card-content {
  position: absolute;
  top: -75px;
  right: 30px;
  width: 271px;
  height: 208px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card .ProductSectionFive-content-card-content:hover {
  transform: scale(1.05);
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card .ProductSectionFive-content-card-content h4 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #1c2640;
  padding: 0;
  margin: 0 0 10px;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card .ProductSectionFive-content-card-content p {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #97a6b7;
  min-height: 80px;
  padding: 0;
  margin: 0;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card .ProductSectionFive-content-card-content a {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #ec6927;
  padding: 0;
  margin: 0;
}
.sectionFive-Product .ProductSectionFive-content .ProductSectionFive-content-card img {
  width: 100%;
  height: auto;
}
.sectionFive-Product .sectionFive-Product-bottom-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 20px;
  color: #ec6927;
  margin-bottom: 50px;
}
.sectionFive-Product #ProductSectionFive-explore-platform-btn {
  background: #ec6927;
  margin-left: 20px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
  padding: 6px 20px;
  font-weight: bold;
  margin-top: 50px;
}
.sectionFive-Product #ProductSectionFive-explore-platform-btn:hover {
  background: #ffffff;
  color: #ec6927;
}
.sectionFive-Product #ProductSectionFive-head {
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 70px;
  margin-top: -100px;
  width: 85%;
  margin-bottom: 10px;
  color: #1c2640 !important;
  text-align: left;
}
.sectionFive-Product #ProductSectionFive-subhead {
  font-style: normal;
  font-weight: normal;
  font-size: 14.5px;
  line-height: 15px !important;
  margin-top: 1%;
  width: 90%;
  text-align: left;
  color: #1c2640 !important;
}
.sectionFive-Product #ProductSectionFive-card-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  grid-gap: 10%;
  gap: 10%;
  margin-top: 5%;
  padding-left: 25px;
}
.sectionFive-Product #ProductSectionFive-card1,
.sectionFive-Product #ProductSectionFive-card2,
.sectionFive-Product #ProductSectionFive-card3 {
  width: 362px;
  height: 286px !important;
  background: #ffffff;
  box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sectionFive-Product #ProductSectionFive-card1-top,
.sectionFive-Product #ProductSectionFive-card2-top,
.sectionFive-Product #ProductSectionFive-card3-top {
  display: flex;
  width: 90%;
  flex-direction: row;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  margin-top: 7%;
  grid-gap: 5%;
  gap: 5%;
  line-height: 1.6;
  font-size: 16px;
  color: #ec6927;
  font-weight: 600;
  padding: 15px 10px 0 30px;
}
.sectionFive-Product #ProductSectionFive-card1-head,
.sectionFive-Product #ProductSectionFive-card2-head,
.sectionFive-Product #ProductSectionFive-card3-head {
  display: flex;
  flex-direction: column;
  width: 70%;
}
.sectionFive-Product #ProductSectionFive-card1-head1,
.sectionFive-Product #ProductSectionFive-card2-head1,
.sectionFive-Product #ProductSectionFive-card3-head1 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1c2640;
}
.sectionFive-Product #ProductSectionFive-card1-head2,
.sectionFive-Product #ProductSectionFive-card2-head2,
.sectionFive-Product #ProductSectionFive-card3-head2 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  color: #1c2640;
  margin-top: 3%;
}
.sectionFive-Product #ProductSectionFive-card1-top img,
.sectionFive-Product #ProductSectionFive-card2-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 70px !important;
}
.sectionFive-Product #ProductSectionFive-card3-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 50px !important;
}
.sectionFive-Product #ProductSectionFive-card1-head,
.sectionFive-Product #ProductSectionFive-card2-head,
.sectionFive-Product #ProductSectionFive-card3-head {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sectionFive-Product #ProductSectionFive-card1-para {
  width: 90%;
  height: 162px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1c2640;
  padding: 5px 15px 0 5px;
}
.sectionFive-Product #ProductSectionFive-card2-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1c2640;
  padding: 5px 15px 0 5px;
}
.sectionFive-Product #ProductSectionFive-card3-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1c2640;
  padding: 5px 15px 0 5px;
}
.sectionFive-Product #ProductSectionFive-discoverAll {
  color: #ec6927;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  width: 90%;
  margin-top: 5%;
  cursor: pointer;
}
.sectionFive-Product div#ProductSectionFive-left-middle-bottom {
  padding: 20px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 3%;
  margin-bottom: 2%;
}
.sectionFive-Product #ProductSectionFive-bottom {
  flex-direction: row;
  justify-content: flex-start;
  background: #fff;
  width: 100%;
  padding: 75px 130px;
  scroll-snap-align: end;
}
.sectionFive-Product .ProductSectionFive-footer-head {
  font-size: 35px;
  color: #1c2640;
}
.sectionFive-Product .ProductSectionFive-footer-content {
  margin-top: 3%;
  display: flex;
}
.sectionFive-Product .ProductSectionFive-btn-footer {
  margin-left: 20%;
}
.sectionFive-Product .ProductSectionFive-footer-disc {
  width: 34%;
}
.sectionFive-Product button#ProductSectionFive-schedule-btn {
  background: #ec6927;
  border-radius: 50px;
  padding: 10px 20px;
  margin-right: 20px;
  color: #fff;
  border: 1px solid #ec6927;
}
.sectionFive-Product button#ProductSectionFive-watch-btn {
  background: #1c2640;
  border-radius: 50px;
  padding: 10px 20px;
  margin-right: 20px;
  color: #fff;
  border: 1px solid #1c2640;
}
.sectionFive-Product img#ProductSectionFive-dots-bg {
  margin-top: -3%;
  float: right;
  width: 200px;
  margin-right: -140px;
  margin-bottom: -200px;
  height: 90px;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/SectionFive/sectionFive.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qCAAA;EACA,WAAA;EACA,0BAAA;AACD;AACC;EACC,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AACF;AACE;EACC,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACH;AACG;EACC,kBAAA;AACJ;AAEG;EACC,iBAAA;AAAJ;AAGG;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AADJ;AAGI;EAEC,sBAAA;AADL;AAII;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAFL;AAKI;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAHL;AAMI;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;AAJL;AAQG;EACC,WAAA;EACA,YAAA;AANJ;AAWC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AATF;AAYC;EACC,mBAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAVF;AAYE;EACC,mBAAA;EACA,cAAA;AAVH;AAcC;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAZF;AAeC;EACC,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;AAbF;AAgBC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;AAdF;AAgBC;;;EAGC,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAdF;AAgBC;;;EAGC,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kCAAA;EACA,sCAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AAdF;AAgBC;;;EAGC,aAAA;EACA,sBAAA;EACA,UAAA;AAdF;AAgBC;;;EAGC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdF;AAiBC;;;EAGC,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAfF;AAkBC;;EAEC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAhBF;AAmBC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAjBF;AAoBC;;;EAGC,aAAA;EACA,sBAAA;EACA,WAAA;AAlBF;AAoBC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AAlBF;AAoBC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AAlBF;AAoBC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AAlBF;AAoBC;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAlBF;AAqBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;AAnBF;AAsBC;EACC,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AApBF;AAuBC;EACC,eAAA;EACA,cAAA;AArBF;AAwBC;EACC,cAAA;EACA,aAAA;AAtBF;AAyBC;EACC,gBAAA;AAvBF;AA0BC;EACC,UAAA;AAxBF;AA2BC;EACC,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAzBF;AA4BC;EACC,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AA1BF;AA6BC;EACC,eAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;AA3BF","sourcesContent":[".sectionFive-Product {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tbackground: rgba(157, 170, 241, 0.32);\n\twidth: 100%;\n\tpadding: 110px 180px 110px;\n\n\t.ProductSectionFive-content {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\twidth: 100%;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 100px;\n\n\t\t.ProductSectionFive-content-card {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tposition: relative;\n\n\t\t\t&:first-child {\n\t\t\t\tmargin-right: 30px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-left: 30px;\n\t\t\t}\n\n\t\t\t.ProductSectionFive-content-card-content {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -75px;\n\t\t\t\tright: 30px;\n\t\t\t\twidth: 271px;\n\t\t\t\theight: 208px;\n\t\t\t\tpadding: 20px;\n\t\t\t\tbackground: #ffffff;\n\t\t\t\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: all 0.3s ease 0s;\n\t\t\t\t\n\t\t\t\t&:hover{\n\t\t\t    \t-webkit-transform: scale(1.05);\n\t\t\t\t\ttransform: scale(1.05);\n\t\t\t    }\n\n\t\t\t\th4 {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 26px;\n\t\t\t\t\tcolor: #1c2640;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0 0 10px;\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 21px;\n\t\t\t\t\tcolor: #97a6b7;\n\t\t\t\t\tmin-height: 80px;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\n\t\t\t\ta {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 34px;\n\t\t\t\t\tcolor: #ec6927;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t}\n\t}\n\n\t.sectionFive-Product-bottom-title {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 43px;\n\t\tline-height: 20px;\n\t\tcolor: #ec6927;\n\t\tmargin-bottom: 50px;\n\t}\n\n\t#ProductSectionFive-explore-platform-btn {\n\t\tbackground: #ec6927;\n\t\tmargin-left: 20px;\n\t\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\t\tborder-radius: 3px;\n\t\tborder: none;\n\t\tcolor: white;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 13.5px;\n\t\tcursor: pointer;\n\t\tpadding: 6px 20px;\n\t\tfont-weight: bold;\n\t\tmargin-top: 50px;\n\n\t\t&:hover {\n\t\t\tbackground: #ffffff;\n\t\t\tcolor: #ec6927;\n\t\t}\n\t}\n\n\t#ProductSectionFive-head {\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tfont-size: 35px;\n\t\tline-height: 70px;\n\t\tmargin-top: -100px;\n\t\twidth: 85%;\n\t\tmargin-bottom: 10px;\n\t\tcolor: #1c2640 !important;\n\t\ttext-align: left;\n\t}\n\n\t#ProductSectionFive-subhead {\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14.5px;\n\t\tline-height: 15px !important;\n\t\tmargin-top: 1%;\n\t\twidth: 90%;\n\t\ttext-align: left;\n\t\tcolor: #1c2640 !important;\n\t}\n\n\t#ProductSectionFive-card-section {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgrid-gap: 10%;\n\t\tgap: 10%;\n\t\tmargin-top: 5%;\n\t\tpadding-left: 25px;\n\t}\n\t#ProductSectionFive-card1,\n\t#ProductSectionFive-card2,\n\t#ProductSectionFive-card3 {\n\t\twidth: 362px;\n\t\theight: 286px !important;\n\t\tbackground: #ffffff;\n\t\tbox-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);\n\t\tborder-radius: 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t#ProductSectionFive-card1-top,\n\t#ProductSectionFive-card2-top,\n\t#ProductSectionFive-card3-top {\n\t\tdisplay: flex;\n\t\twidth: 90%;\n\t\tflex-direction: row;\n\t\talign-items: flex-start !important;\n\t\tjustify-content: flex-start !important;\n\t\tmargin-top: 7%;\n\t\tgrid-gap: 5%;\n\t\tgap: 5%;\n\t\tline-height: 1.6;\n\t\tfont-size: 16px;\n\t\tcolor: #ec6927;\n\t\tfont-weight: 600;\n\t\tpadding: 15px 10px 0 30px;\n\t}\n\t#ProductSectionFive-card1-head,\n\t#ProductSectionFive-card2-head,\n\t#ProductSectionFive-card3-head {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70%;\n\t}\n\t#ProductSectionFive-card1-head1,\n\t#ProductSectionFive-card2-head1,\n\t#ProductSectionFive-card3-head1 {\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tcolor: #1c2640;\n\t}\n\n\t#ProductSectionFive-card1-head2,\n\t#ProductSectionFive-card2-head2,\n\t#ProductSectionFive-card3-head2 {\n\t\tfont-style: normal;\n\t\tfont-weight: bold;\n\t\tfont-size: 24px;\n\t\tline-height: 20px;\n\t\tcolor: #1c2640;\n\t\tmargin-top: 3%;\n\t}\n\n\t#ProductSectionFive-card1-top img,\n\t#ProductSectionFive-card2-top img {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70px !important;\n\t\theight: 70px !important;\n\t}\n\n\t#ProductSectionFive-card3-top img {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 70px !important;\n\t\theight: 50px !important;\n\t}\n\n\t#ProductSectionFive-card1-head,\n\t#ProductSectionFive-card2-head,\n\t#ProductSectionFive-card3-head {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t}\n\t#ProductSectionFive-card1-para {\n\t\twidth: 90%;\n\t\theight: 162px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 25px;\n\t\tcolor: #1c2640;\n\t\tpadding: 5px 15px 0 5px;\n\t}\n\t#ProductSectionFive-card2-para {\n\t\twidth: 90%;\n\t\theight: 153px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 25px;\n\t\tcolor: #1c2640;\n\t\tpadding: 5px 15px 0 5px;\n\t}\n\t#ProductSectionFive-card3-para {\n\t\twidth: 90%;\n\t\theight: 153px;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 14px;\n\t\tline-height: 25px;\n\t\tcolor: #1c2640;\n\t\tpadding: 5px 15px 0 5px;\n\t}\n\t#ProductSectionFive-discoverAll {\n\t\tcolor: #ec6927;\n\t\tfont-weight: 500;\n\t\tfont-size: 20px;\n\t\tline-height: 20px;\n\t\twidth: 90%;\n\t\tmargin-top: 5%;\n\t\tcursor: pointer;\n\t}\n\n\tdiv#ProductSectionFive-left-middle-bottom {\n\t\tpadding: 20px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tdisplay: flex;\n\t\tmargin: 3%;\n\t\tmargin-bottom: 2%;\n\t}\n\n\t#ProductSectionFive-bottom {\n\t\tflex-direction: row;\n\t\tjustify-content: flex-start;\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tpadding: 75px 130px;\n\t\tscroll-snap-align: end;\n\t}\n\n\t.ProductSectionFive-footer-head {\n\t\tfont-size: 35px;\n\t\tcolor: #1c2640;\n\t}\n\n\t.ProductSectionFive-footer-content {\n\t\tmargin-top: 3%;\n\t\tdisplay: flex;\n\t}\n\n\t.ProductSectionFive-btn-footer {\n\t\tmargin-left: 20%;\n\t}\n\n\t.ProductSectionFive-footer-disc {\n\t\twidth: 34%;\n\t}\n\n\tbutton#ProductSectionFive-schedule-btn {\n\t\tbackground: #ec6927;\n\t\tborder-radius: 50px;\n\t\tpadding: 10px 20px;\n\t\tmargin-right: 20px;\n\t\tcolor: #fff;\n\t\tborder: 1px solid #ec6927;\n\t}\n\n\tbutton#ProductSectionFive-watch-btn {\n\t\tbackground: #1c2640;\n\t\tborder-radius: 50px;\n\t\tpadding: 10px 20px;\n\t\tmargin-right: 20px;\n\t\tcolor: #fff;\n\t\tborder: 1px solid #1c2640;\n\t}\n\n\timg#ProductSectionFive-dots-bg {\n\t\tmargin-top: -3%;\n\t\tfloat: right;\n\t\twidth: 200px;\n\t\tmargin-right: -140px;\n\t\tmargin-bottom: -200px;\n\t\theight: 90px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
